import PVDesignViewer from "./PVDesignViewer";
import { PVRooftopPolygonsSelection } from "./PVRooftopPolygonsSelection";
import { useSelector } from "react-redux";

const PVDesign3DComponents = () => {
  const { isPVDesignActive } = useSelector((state) => state.pvDesign);

  if (!isPVDesignActive) return null;
  return (
    <>
      <PVRooftopPolygonsSelection />
      <PVDesignViewer />
    </>
  );
};

export default PVDesign3DComponents;
